/**
 * Helper function for making authenticated API requests with tenant context
 */
export async function authenticatedFetch(url: string, options: RequestInit = {}): Promise<Response> {
  const token = localStorage.getItem('auth_token');
  const tenantId = localStorage.getItem('selected_tenant_id') || localStorage.getItem('superadmin_selected_tenant');

  const headers: HeadersInit = {
    'Content-Type': 'application/json',
    ...options.headers,
  };

  if (token) {
    (headers as Record<string, string>).Authorization = `Bearer ${token}`;
  }

  // Adicionar tenant ID no header para SuperAdmin
  if (tenantId) {
    (headers as Record<string, string>)['X-Tenant-Id'] = tenantId;
  }

  return fetch(url, {
    ...options,
    headers,
  });
}
